import React from 'react'
import { Col, Row, Button } from 'antd'
import { DeleteOutlined } from '@ant-design/icons'

import __ from '../../languages/parser'

// eslint-disable-next-line no-unused-vars
const SelectedElement = ({ selectedElement, elements, removeElement }) => {
  const element = elements.filter((el) => el.id === selectedElement)[0] || null
  return (
    <div style={{ width: '100%', height: '32px' }}>
      {element ? (
        <Row justify="center">
          <Col>
            <div style={{
              fontSize: '0.8em',
              fontWeight: '500',
              textAlign: 'right',
              width: '100%',
              lineHeight: '28px',
              color: '#385623',
            }}
            >
              {__(element.type)}
            </div>
          </Col>
          <Col offset={1} span={2}>
            <Button size="small" type="link" block onClick={() => removeElement(selectedElement)}>
              <DeleteOutlined />

            </Button>
          </Col>
        </Row>
      )
        : null}
    </div>


  )
}

export default SelectedElement
